import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Building2, Cpu, Landmark } from "lucide-react";
import { Seo } from "../components/layout/Seo";
import { Section } from "../components/ui/Section";
import { LeadForm } from "../components/forms/LeadForms";

type Flow = "moldova" | "israel" | "institution" | "generic" | "green-wine";

const cards: Array<{ flow: Flow; icon: typeof Building2; labelKey: string }> = [
  { flow: "moldova", icon: Building2, labelKey: "contact.moldova" },
  { flow: "israel", icon: Cpu, labelKey: "contact.israel" },
  { flow: "institution", icon: Landmark, labelKey: "contact.institution" }
];

export function Contact() {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const activeFlow = (params.get("flow") || "generic") as Flow;
  const formKind = activeFlow === "green-wine" ? "moldova" : activeFlow;

  return (
    <>
      <Seo title={t("contact.title")} description={t("contact.intro")} />
      <Section title={t("contact.title")} intro={t("contact.intro")} className="pt-[calc(var(--header-height)+72px)]">
        <div className="mb-10 grid gap-4 md:grid-cols-3">
          {cards.map(({ flow, icon: Icon, labelKey }) => (
            <button key={flow} type="button" className={`min-h-36 border p-6 text-start transition ${activeFlow === flow ? "border-brand-blue bg-surface" : "border-line bg-transparent hover:bg-surface"}`} onClick={() => setParams({ flow })}>
              <Icon className="mb-6 h-7 w-7 text-brand-blue" />
              <span className="text-xl font-bold">{t(labelKey)}</span>
            </button>
          ))}
        </div>
        <LeadForm kind={formKind === "generic" ? "institution" : formKind} />
      </Section>
    </>
  );
}
